import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { PersonModel } from '@bayclubs/court-booking-employee-api';

import { CourtBookingSaveFacade } from '../../+store/court-booking-save.facade';

@Component({
    selector: 'app-court-booking-save-player-search',
    templateUrl: './court-booking-save-player-search.component.html',
    styleUrls: ['./court-booking-save-player-search.component.scss'],
    standalone: false
})
export class CourtBookingSavePlayerSearchComponent implements OnInit, OnDestroy {
    @Input() players: PersonModel[];
    @Output() selectPerson: EventEmitter<PersonModel> = new EventEmitter();

    form: UntypedFormGroup;

    subscription: Subscription = new Subscription();

    constructor(private formBuilder: UntypedFormBuilder, private courtBookingSaveFacade: CourtBookingSaveFacade) { }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            search: [null]
        });
        this.initFormSubscription();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    initFormSubscription() {
        this.subscription.add(
            this.form.controls.search.valueChanges.pipe(debounceTime(1000)).subscribe(value => {
                this.courtBookingSaveFacade.searchPlayers(value);
            })
        );
    }

    onSelectPerson(person: PersonModel) {
        this.form.controls.search.setValue(null);
        this.selectPerson.emit(person);
    }

    get showPlayerList(): boolean {
        return (
            this.players &&
            this.players.length > 0 &&
            this.form.controls.search.value !== null &&
            this.form.controls.search.value !== '' &&
            this.form.controls.search.value !== undefined
        );
    }
}
